



import { Component, Vue, Prop } from 'vue-property-decorator'
import marked from 'marked'

@Component({
  name: 'markdownParser'
})
export default class extends Vue {
  @Prop({ default: false }) markdownString!: string

  get parseMd() {
    return marked(this.markdownString, {
      headerIds: false
    })
  }
}
